import React, { Fragment } from 'react';

const Intro_1 = () => (
  <Fragment>
<div>
  <h4>1.2.3 Conversion to String</h4>
  <p>
    To convert a value to a string, the <code>str()</code> function is used.
  </p>
  <pre><code>
number = 10 <br />
text = str(number)
  </code></pre>
</div>
  </Fragment>
);
export default Intro_1;
